import { useQuery } from '@tanstack/react-query';

import type { AdminUser } from 'app/typings';
import { apiRequest } from 'app/utils/request/api';

const hotelManagerPath = '/extranet/:hotelId/manager' as const;

export function useHotelManager(hotelId?: number) {
  return useQuery<AdminUser | null>({
    queryKey: [hotelManagerPath, { hotelId }],
    queryFn: !!hotelId
      ? () =>
          apiRequest({
            path: hotelManagerPath,
            params: { hotelId: hotelId.toString() },
          })
      : undefined,
    staleTime: Infinity,
    enabled: !!hotelId,
  });
}
